export const ONLINE = 1; // Website is online
export const SUBSCRIPTION = 2; // Event subscriptions open
export const EVALUATION = 3; // Event evaluation forms open
export const LIVE_EVENT = 4; // Event evaluation forms open
export const ON_DEMAND_EVENT = 5; // Event evaluation forms open
export const ACTIVE_PLAYER = 6; // Episode player is visible
export const ON_SITE_EVENT = 7; // Episode player is visible
export const SUNSET = 8; // Episode player is visible

export const SCHEDULE_CERTIFICATE_REMINDER = 11;
export const SCHEDULE_CERTIFICATE_DELIVERY = 12;

export const LIVE_REMINDER = 21;
export const LIVE_ONDEMAND_REMINDER = 22;
export const ONDEMAND_REMINDER = 23;
export const VPN_REMINDER = 24;
export const MEET_THE_EXPERTS_REMINDER = 25;

export const LIVE_ATTENDED_EVENT = 27;
export const LIVE_NOT_ATTENDED_EVENT = 28;

export const LIVE_REMINDER_ONE_WEEK_PRIOR = 31;
export const LIVE_REMINDER_ONE_DAY_PRIOR = 32;
export const LIVE_REMINDER_ONE_HOUR_PRIOR = 33;
export const ONDEMAND_REMINDER_MISSING_TIME = 34; // Remaining time
export const SUBSCRIBER_REGISTRATION_CONFIRMED_REMINDER = 61; 
export const SUBSCRIBER_REGISTRATION_NOT_CONFIRMED_REMINDER = 62;
export const NATIONAL_MEETING_US_CA_DUCATI = 63;
export const NATIONAL_MEETING_MX_DUCATI = 64;

export const FORCE_EF_ON_LOGOUT = 9001;

export const DISABLE_EPISODE = [1]
